<template>
  <v-card outlined>
    <v-card-title class="d-flex justify-space-between">
      <span>
        {{ localResult.sortition.name }} &nbsp;
        <span class="font-weight-bold"
          >({{ localResult.sortition.abbreviation }})</span
        >
      </span>
    </v-card-title>
    <v-card-text>
      <validation-observer ref="validationObserver">
        <v-row>
          <v-col v-if="localResult.requiredFields.first"
                 lg="2"
                 md="3"
                 cols="6">
            <validation-provider
              slim
              mode="eager"
              :rules="
                localResult.fillableFields.first ? 'required|length:2' : null
              "
              v-slot="{ errors }">
              <result-field-editor
                ref="first"
                v-model="localResult.first"
                :disabled="!localResult.fillableFields.first"
                :maxlength="2"
                label="First"
                :error-messages="errors"
                @complete="$refs.second.focus()">
              </result-field-editor>
            </validation-provider>
          </v-col>
          <v-col v-if="localResult.requiredFields.second"
                 lg="2"
                 md="3"
                 cols="6">
            <validation-provider
              slim
              mode="eager"
              :rules="
                localResult.fillableFields.second ? 'required|length:2' : null
              "
              v-slot="{ errors }">
              <result-field-editor
                ref="second"
                v-model="localResult.second"
                :disabled="!localResult.fillableFields.second"
                :maxlength="2"
                label="Second"
                :error-messages="errors"
                @complete="$refs.third.focus()"
              >
              </result-field-editor>
            </validation-provider>
          </v-col>
          <v-col v-if="localResult.requiredFields.third"
                 lg="2"
                 md="3"
                 cols="6">
            <validation-provider
              slim
              mode="eager"
              :rules="
                localResult.fillableFields.third ? 'required|length:2' : null
              "
              v-slot="{ errors }"
            >
              <result-field-editor
                ref="third"
                v-model="localResult.third"
                :disabled="!localResult.fillableFields.third"
                :maxlength="2"
                label="Third"
                :error-messages="errors"
                @complete="$refs.pickTwo.focus()"
              >
              </result-field-editor>
            </validation-provider>
          </v-col>
	        <v-col v-if="localResult.requiredFields.pickOne"
	               lg="2"
	               md="3"
	               cols="6">
		        <validation-provider
			        slim
			        mode="eager"
			        :rules="
                localResult.fillableFields.pickOne ? 'required|length:1' : null
              "
			        v-slot="{ errors }"
		        >
			        <result-field-editor
				        ref="pickOne"
				        v-model="localResult.pickOne"
				        :disabled="!localResult.fillableFields.pickOne"
				        :maxlength="1"
				        label="Pick One"
				        :error-messages="errors"
				        @complete="$refs.pickTwo && $refs.pickTwo.focus()"
			        >
			        </result-field-editor>
		        </validation-provider>
	        </v-col>
	        <v-col v-if="localResult.requiredFields.pickTwo"
	               lg="2"
                 md="3"
                 cols="6">
            <validation-provider
              slim
              mode="eager"
              :rules="
                localResult.fillableFields.pickTwo ? 'required|length:2' : null
              "
              v-slot="{ errors }"
            >
              <result-field-editor
                ref="pickTwo"
                v-model="localResult.pickTwo"
                :disabled="!localResult.fillableFields.pickTwo"
                :maxlength="2"
                label="Pick Two"
                :error-messages="errors"
                @complete="$refs.cashThree && $refs.cashThree.focus()"
              >
              </result-field-editor>
            </validation-provider>
          </v-col>
          <v-col v-if="localResult.requiredFields.cashThree"
                 lg="2"
                 md="3"
                 cols="6">
            <validation-provider
              slim
              mode="eager"
              :rules="
                localResult.fillableFields.cashThree
                  ? 'required|length:3'
                  : null
              "
              v-slot="{ errors }"
            >
              <result-field-editor
                ref="cashThree"
                v-model="localResult.cashThree"
                :disabled="!localResult.fillableFields.cashThree"
                :maxlength="3"
                label="Cash 3"
                :error-messages="errors"
                @complete="$refs.pickFour && $refs.pickFour.focus()"
              >
              </result-field-editor>
            </validation-provider>
          </v-col>
          <v-col v-if="localResult.requiredFields.pickFour"
                 lg="2"
                 md="3"
                 cols="6">
            <validation-provider
              slim
              mode="eager"
              :rules="
                localResult.fillableFields.pickFour ? 'required|length:4' : null
              "
              v-slot="{ errors }"
            >
              <result-field-editor
                ref="pickFour"
                v-model="localResult.pickFour"
                :disabled="!localResult.fillableFields.pickFour"
                :maxlength="4"
                label="Pick 4"
                :error-messages="errors"
                @complete="$refs.pickFive && $refs.pickFive.focus()"
              >
              </result-field-editor>
            </validation-provider>
          </v-col>
          <v-col v-if="localResult.requiredFields.pickFive"
                 lg="2"
                 md="3"
                 cols="12">
            <validation-provider
              slim
              mode="eager"
              :rules="
                localResult.fillableFields.pickFive ? 'required|length:5' : null
              "
              v-slot="{ errors }"
            >
              <result-field-editor
                ref="pickFive"
                v-model="localResult.pickFive"
                :disabled="!localResult.fillableFields.pickFive"
                :maxlength="5"
                label="Pick 5"
                :error-messages="errors"
              >
              </result-field-editor>
            </validation-provider>
          </v-col>
        </v-row>
      </validation-observer>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="danger" text @click="$emit('close')">
        <font-awesome-icon icon="ban" class="mr-1"> </font-awesome-icon>
        Discard
      </v-btn>
      <v-btn color="success" :disabled="!changed" text @click="onSave">
        <font-awesome-icon icon="save" class="mr-1"> </font-awesome-icon>
        Save
      </v-btn>
    </v-card-actions>
    <result-save-dialog
      v-model="confirmationDialog"
      :result="localResult"
      :date="date"
      @confirm="onConfirm"
    >
    </result-save-dialog>
  </v-card>
</template>

<script>
import isEqual from "lodash/isEqual.js";
import ResultFieldEditor from "./ResultFieldEditor.vue";
import ResultSaveDialog from "./ResultSaveDialog.vue";
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";

import { required, length } from "vee-validate/dist/rules";

extend("length", {
  ...length,
  message: "Must have {length} digits."
});

extend("required", {
  ...required,
  message: "Cannot be blank."
});

export default {
  name: "ResultEditor",
  components: {
    ResultSaveDialog,
    ResultFieldEditor,
    ValidationProvider,
    ValidationObserver
  },
  props: {
    date: {
      type: String,
      required: true
    },
    result: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      localResult: {},
      confirmationDialog: false
    };
  },
  computed: {
    changed() {
      return !isEqual(this.localResult, this.result);
    }
  },
  watch: {
    "localResult.cashThree": "autoCompleteFirst",
    "localResult.pickFour": "autoCompleteSecondAndThird",
    result: {
      handler(result) {
        this.syncLocalResult(result);
      },
      immediate: true
    }
  },
  methods: {
    autoCompleteFirst(value) {
      if (this.localResult.requiredFields.cashThree) {
        if (value?.length === 3) {
          const first = value.slice(1, 3);

          this.$set(this.localResult, "first", first);
        } else {
          this.$set(this.localResult, "first", null);
        }
      }
    },
    autoCompleteSecondAndThird(value) {
      if (this.localResult.requiredFields.pickFour) {
        if (value?.length === 4) {
          const second = value.slice(0, 2),
            third = value.slice(2, 4);

          this.$set(this.localResult, "second", second);
          this.$set(this.localResult, "third", third);
        } else {
          this.$set(this.localResult, "second", null);
          this.$set(this.localResult, "third", null);
        }
      }
    },
    async onSave() {
      const isValid = await this.$refs.validationObserver.validate();

      if (isValid) {
        this.confirmationDialog = true;
      }
    },
    onConfirm() {
      this.autoCompleteFirst(this.localResult?.cashThree);
      this.autoCompleteSecondAndThird(this.localResult?.pickFour);
      this.$emit("save", { result: this.localResult });
    },
    syncLocalResult(result) {
      this.localResult = { ...result };
    }
  }
};
</script>

<style scoped></style>
